import { useMemo } from "react";
import { isAfter, isBefore } from "date-fns";
import { useWidgetData } from "../WidgetDataContext";

export function useChallengeOverviewStats() {
  const { filteredAccounts, dateRange } = useWidgetData();
  const start = dateRange.from ?? null;
  const end = dateRange.to ?? null;

  return useMemo(() => {
    const totalAccounts = filteredAccounts?.length ?? 0;

    const accountsWithPayout = (filteredAccounts ?? []).filter((acc) => {
      const payouts = (acc.payouts ?? []) as { date: Date | string }[];
      return payouts.some((p) => {
        const d = new Date(p.date);
        // exclusive bounds: matches usePfmKpis convention
        if (start && !isAfter(d, start)) return false;
        if (end && !isBefore(d, end)) return false;
        return true;
      });
    }).length;

    const ratio = totalAccounts > 0 ? (accountsWithPayout / totalAccounts) * 100 : 0;

    return { totalAccounts, accountsWithPayout, ratio };
  }, [filteredAccounts, start, end]);
}
